"use client";

import { c as _c } from "react/compiler-runtime";
import { Quote } from "lucide-react";
import type { CampaignPageSection } from "@growwithai/shared";
import SafeImage from "@/components/common/SafeImage";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type TestimonialsProps = Extract<CampaignPageSection, {
  type: "testimonials";
}>;

/** Grid testimoni: quote + foto/inisial + nama + peran. */
export default function TestimonialsSection(t0) {
  const $ = _c(17);
  const {
    section
  } = t0;
  if (section.items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== section.custom_style) {
    t1 = sectionBgStyle(section.custom_style);
    $[0] = section.custom_style;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== section.custom_style) {
    t2 = sectionHeadingStyle(section.custom_style);
    $[2] = section.custom_style;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = section.heading ?? "Kata Mereka";
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <h2 className="text-center text-2xl font-bold tracking-tight text-warm-black md:text-3xl" style={t2}>{t3}</h2>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== section.items) {
    t5 = section.items.map(_temp);
    $[7] = section.items;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">{t5}</div>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div className="mx-auto max-w-6xl px-5">{t4}{t6}</div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t1 || $[15] !== t7) {
    t8 = <section className="bg-white py-14 md:py-20" style={t1}>{t7}</section>;
    $[14] = t1;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp(item, i) {
  return <figure key={i} className="flex flex-col rounded-2xl border [border-color:var(--card-border-color,rgba(0,0,0,.06))] bg-warm-cream/60 p-5 shadow-[var(--card-shadow,none)] [backdrop-filter:var(--card-backdrop,none)]"><Quote className="h-5 w-5 text-[var(--brand-primary)] opacity-60" /><blockquote className="mt-3 flex-1 text-[15px] leading-relaxed text-gray-700">“{item.quote}”</blockquote><figcaption className="mt-4 flex items-center gap-3">{item.photo_url ? <SafeImage src={item.photo_url} alt={item.name} loading="lazy" className="h-10 w-10 rounded-full border border-black/[0.06] object-cover" /> : <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[var(--brand-primary)]/10 text-sm font-bold text-[var(--brand-primary)]">{item.name.charAt(0).toUpperCase()}</span>}<div className="min-w-0"><p className="truncate text-sm font-semibold text-warm-black">{item.name}</p>{item.role && <p className="truncate text-xs text-gray-500">{item.role}</p>}</div></figcaption></figure>;
}